import { useState } from "react";
import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { Box } from "@chakra-ui/react";

export interface SelectCnabProps<T = any> extends SelectProps<T> {
    value: any;
    onChange: (v: any, item: any) => void;
    isInvalid?: boolean;
  }

function SelectCnab({
    value,
    onChange,
    isInvalid,
    ...rest
}: SelectCnabProps) {
    const [search, setSearch] = useState<string | undefined>();

    return(
        <SelectBaseAntd
            isInvalid={isInvalid}
            // loading={isLoading}
            size="large"
            placeholder="Selecione o CNAB"
            value={value || undefined}
            onChange={onChange}
            searchValue={search}
            onSearch={setSearch}
            showSearch
            allowClear
            optionFilterProp="label"
            options={[
                {
                    value: 240,
                    label: "240 (recomendado)"
                },
                {
                    value: 400,
                    label: "400"
                }
            ]}
            {...rest}
            notFoundContent={<Box>Nenhum CNAB encontrado</Box>}
        />
    )
}

export default SelectCnab